import type { JSX, ReactElement } from 'react'
import { focusWithinOutline, Sheet } from '@sunwebgroup/ui-components/uds'
import { useState } from 'react'
import { styled } from 'styled-components'
import { useCMSPageField } from '@/cms/fields'
import { useIntl } from '@/intl'
import { AlertServiceSidebar } from '@/scopes/common/components/AlertService/index'

const UnavailableLink = styled.button`
  position: relative;
  text-decoration: underline;
  cursor: pointer;
  ${focusWithinOutline()};
`

export function SubscribeLink({ accommodationId, linkContent }: { accommodationId: number, linkContent: (string | JSX.Element)[] }): ReactElement {
  const [isOpen, setIsOpen] = useState(false)
  const intl = useIntl()
  const contextItemId = useCMSPageField('contextItemId')

  return (
    <Sheet.Root open={isOpen} onOpenChange={setIsOpen}>
      <Sheet.Trigger>
        <UnavailableLink as="a">
          { linkContent}
        </UnavailableLink>
      </Sheet.Trigger>
      <Sheet.Body side="right">
        <Sheet.Header
          titleLabel={intl.formatMessage({ id: 'product_card_unavailable_banner-sheet_title' })}
          closeLabel={intl.formatMessage({ id: 'close' })}
        />
        <Sheet.Content>
          <AlertServiceSidebar contextItemId={contextItemId} accommodationId={accommodationId} />
        </Sheet.Content>
      </Sheet.Body>
    </Sheet.Root>
  )
}
